const listeners = new Set<(userId: string) => void>();
export const subscribeReminderChanges = (listener: (userId: string) => void) => { listeners.add(listener); return () => { listeners.delete(listener); }; };
/** Invalidate owned reads; historical receipt rows never replace current data. */
export const publishReminderRefresh = (userId: string) => { for (const listener of listeners) listener(userId); };
